
import Vuex from "vuex";
import Vue from "vue";

import TripStore from "./trip";
import globalStore from "./global_store";
import login from "./login";
import register from "./register";
import dashboard from "./dashboard";
import contact from "./contact";
import tripsStore from "./trips";
import resetPassword from "./reset-password";
import changePassword from "./change-password";
import tripReport from './trips_reports';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        trip: TripStore,
        globalStore,
        login,
        register,
        dashboard,
        contact,
        trips: tripsStore,
        resetPassword,
        changePassword,
        tripReport,
    }
})


export default store
